var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('mdb-parallax',{staticClass:"z-depth-4",attrs:{"src":("" + (_vm.block.value.image.original.src)),"height":"half","factor":"1.3"}})}
var staticRenderFns = []

export { render, staticRenderFns }